import { AppMarkdownParser } from "../../../../shared/components/AppMarkdownParser";
import { CopyButton } from "../../../Components/Buttons/CopyButton";
import styles from "./styles.module.css";

interface Props {
  content: string;
  hasCopyButton: boolean;
}

export const AudioTranscriptionResult = ({ content, hasCopyButton }: Props) => {
  return (
    <div className={styles.success}>
      {hasCopyButton && (
        <CopyButton copyContent={content} className={styles["copy"]} />
      )}
      <AppMarkdownParser content={content} />
    </div>
  );
};
